import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  checkbox: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
});

export default useStyles;
